"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagDetailsSchema = exports.RecentTagDetailsSchema = exports.ObservationSchema = exports.UpdateLocationQueueBodySchema = void 0;
const zod_1 = require("zod");
const activity_1 = require("../lib/activity");
const token_1 = require("../misc/token");
const activities_1 = require("../model/activities");
exports.UpdateLocationQueueBodySchema = zod_1.z.object({
    auth: zod_1.z.string(),
    scope: zod_1.z.literal("cerestag"),
    externalIds: token_1.ExternalIdsSchema.pick({
        ceres_tag_esn: true
    }).required(),
    type: zod_1.z.literal(activity_1.ActivityTypeSchema.enum.addMovement),
    details: activities_1.ceresTagDataSchema,
    createdAt: zod_1.z.string(),
});
exports.ObservationSchema = zod_1.z.object({
    observationDateUTC: zod_1.z.string(),
    esn: zod_1.z.string(),
    data: zod_1.z.array(zod_1.z.string().nullable())
});
exports.RecentTagDetailsSchema = zod_1.z.object({
    statusCode: zod_1.z.number(),
    errorMessage: zod_1.z.string().nullable(),
    resultItem: zod_1.z.object({
        observations: zod_1.z.array(exports.ObservationSchema)
    })
});
exports.TagDetailsSchema = zod_1.z.object({
    propertyTags: zod_1.z.array(zod_1.z.object({
        identifiers: zod_1.z.array(zod_1.z.string()),
        tags: zod_1.z.array(zod_1.z.object({
            esn: zod_1.z.string(),
            vid: zod_1.z.string(),
            rfid: zod_1.z.string(),
            btMac: zod_1.z.string(),
        }))
    }))
});
